import { useCheckoutStore } from "../store/useCheckoutStore";
import { useRedebanStore } from "../store/useRedebanStore";
import { userStore } from "../store/userStore";
import { useVizionarioStore } from "../store/useVizionarioStore";
import { getCombosToPay } from "../utils/confectioneryManager";
import axiosInstance from "./api";

const getData = () => {
  const { kioskData } = userStore.getState();
  const { isVizionario, userData } = useVizionarioStore.getState();

  const {
    consecutive,
    bookingDetails: {
      subtotal,
      totalService,
      total,
      showtime,
      confectioneryCombos,
    },
    selectedSeats,
    confectioneries_api,
  } = useCheckoutStore.getState();
  let theaterId = kioskData.complement.theater.id ?? 1;
  let scorePaymentMethod = kioskData.complement.payment_method ?? "10";

  const data = {
    subtotal,
    total_service: totalService,
    total,
    device: "kiosk",
    showtime_id: showtime.id,
    score_consecutive: consecutive?.Secuencia,
    score_payment_method: scorePaymentMethod,
    theater_id: theaterId,
    seats: selectedSeats,
    pay_type: 1,
    pay_status_id: 11,
  };

  if (isVizionario && userData) {
    data.email = userData.email;
  }

  if (confectioneryCombos.length) {
    const { product, productsDetail, description } = getCombosToPay(
      confectioneryCombos,
      confectioneries_api,
      isVizionario
    );

    data.products = product;
    data.products_detail = productsDetail;
    data.products_description = description;
  }

  return data;
};

const saleTicket = async () => {
  const data = getData();

  const response = await axiosInstance.post("kiosks/sale", data);
  return response;
};

const onPrint = async ({ showtime, movie, qrs, scoreResponse }) => {
  const { kioskData } = userStore.getState();
  const { setCurrentExplanation } = useRedebanStore.getState();

  setCurrentExplanation(7);

  const {
    complement: { printer_name },
  } = kioskData;

  const numberFormat = new Intl.NumberFormat("es-CO");

  const format = (number) => {
    number = numberFormat.format(parseInt(number));
    return `$${number}`;
  };

  let html = `
    <div style="text-align: center; font-weight: bold; margin-bottom: 20px">
      ${scoreResponse["Nombre"]}<br />
      NIT: ${scoreResponse["NIT"]}<br />
      ${scoreResponse["NomTeatro"]}
    </div>
    <div style="text-align: center; font-size: 13px">
      <p style="margin-bottom: 5px">Sucursal: ${scoreResponse["Sucursal"]}</p>
    </div>
    <p style="margin-bottom: 10px; font-size: 13px">
      <strong>Cliente:</strong> ${scoreResponse["Cliente"]}<br />
      <strong>Ced/NIT:</strong> ${scoreResponse["Ced/NIT"]}<br />
      <strong>Teléfono:</strong> ${scoreResponse["Telefono"]}<br />
      <strong>Correo:</strong> ${scoreResponse["Correo"]}<br />
    </p>
    <hr />
    <table border="0" cellpadding="0" cellspacing="0" style="width: 100%; margin-top: 10px; margin-bottom: 10px; font-size: 13px;">
      <thead>
        <tr>
          <td style="font-weight: bold; width: 18%;">Cant.</td>
          <td style="font-weight: bold; width: 42%;">Producto</td>
          <td style="font-weight: bold; width: 40%; text-align: right;">Total</td>
        </tr>
      </thead>
      <tbody>
  `;
  scoreResponse["Ventas"].forEach((item) => {
    html += `
        <tr>
          <td style="width: 18%;">${item["Cantidad"]}</td>
          <td style="width: 42%;">${item["Producto"]}</td>
          <td style="width: 40%; text-align: right;">
            ${format(item["Total"])}
          </td>
        </tr>
    `;
  });
  html += `
        </tbody>
      </table>
      <hr />
  `;
  if (
    scoreResponse["Bases"] &&
    scoreResponse["Bases"]["SinIva"] &&
    scoreResponse["Bases"]["IVA 19%"]
  ) {
    html += `
      <div style="margin-bottom: 20px; margin-top: 10px;">
        <table border="0" cellpadding="0" cellspacing="0" style="width: 100%; font-size: 13px;">
          <tr>
            <td style="width: 50%;">Productos sin IVA</td>
            <td style="width: 50%; text-align: right;">
              ${format(scoreResponse["Bases"]["SinIva"])}
            </td>
          </tr>
          <tr>
            <td style="width: 50%;">Productos con impoconsumo %0</td>
            <td style="width: 50%; text-align: right;">$0</td>
          </tr>
          <tr>
            <td style="width: 50%;">Producto con IVA</td>
            <td style="width: 50%; text-align: right;">
              ${format(scoreResponse["Bases"]["IVA 19%"])}
            </td>
          </tr>
        </table>
      </div>
    `;
  }
  html += `
      <div style="margin-bottom: 20px; margin-top: 10px;">
        <table border="0" cellpadding="0" cellspacing="0" style="width: 100%; font-size: 13px;">
          <tr>
            <td style="width: 50%; font-weight: bold;">Total</td>
            <td style="width: 50%; text-align: right; font-weight: bold;">
              ${format(scoreResponse["Total"])}
            </td>
          </tr>
        </table>
      </div>
      <div style='text-align: center; font-size: 11px;'>
        Caja: ${scoreResponse["Caja"]}
      </div>
      <div style='text-align: center; font-size: 11px;'>
        ${scoreResponse["DescFinal"]}
      </div>
  `;
  const electron = window.require("electron");
  const printOptions = {
    silent: true,
    deviceName: printer_name,
    margins: { marginType: "none" },
    printBackground: true,
  };

  await electron.ipcRenderer.send(
    "print",
    printOptions,
    html,
    scoreResponse["NomTeatro"],
    showtime,
    movie,
    qrs
  );

  setCurrentExplanation(8);
};

const updateSale = async (consecutive, status) => {
  const { setStartTimer, setCurrentExplanation } = useRedebanStore.getState();

  const data = getData();
  data.pay_status_id = status;
  try {
    const response = await axiosInstance.put(
      `kiosks/sale/${consecutive}`,
      data
    );

    const {
      data: {
        data: {
          showtime,
          movie,
          qrs,
          score_bill: { score_response },
        },
      },
    } = response;

    if (score_response) {
      onPrint({ showtime, movie, qrs, scoreResponse: score_response });
    }

    return response;
  } catch (error) {
    console.error(error);
  } finally {
    setStartTimer(false);
    if (status !== 1) {
      const explanationCode = status === 10 ? 9 : 6;
      setCurrentExplanation(explanationCode);
    } else {
      setCurrentExplanation(5);
    }
  }
};

const redebanToken = async () => {
  try {
    const response = await axiosInstance.post("redeban/token");
    return response.data.token;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const redebanPay = async (token, consecutive) => {
  const {
    bookingDetails: { total },
  } = useCheckoutStore.getState();

  const data = {
    transation_id: consecutive,
    token,
    total,
    tip: 0,
    iva: 0,
    return: 0,
    consumption: 0,
    base_iva: 0,
    base_consumption: 0,
    minutes: 3,
    overwrite: "S",
  };

  try {
    const response = await axiosInstance.post("redeban/pay", data);
    return response.data.response;
  } catch (error) {
    console.error(error);
    return null;
  }
};

const redebanResponse = async (token, consecutive) => {
  const data = {
    transation_id: consecutive,
    token,
  };

  try {
    const response = await axiosInstance.post("redeban/response", data);
    return response.data.response;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const redebanCancel = async (token, consecutive) => {
  const { setInProgress } = useRedebanStore.getState();

  const data = {
    transation_id: consecutive,
    token,
  };

  try {
    const response = await axiosInstance.post("redeban/cancel", data);

    if (response.status === 200) {
      setInProgress(false);
    }
  } catch (error) {
    console.error(error);
  }
};

export const pay = async (showtimeId) => {
  const {
    setInProgress,
    setCurrentTransaction,
    setStartTimer,
    setCurrentExplanation,
  } = useRedebanStore.getState();
  setInProgress(true);
  setCurrentExplanation(1);

  try {
    const statusSale = await saleTicket(showtimeId);

    if (statusSale && statusSale.data.consecutive) {
      const consecutive = statusSale.data.consecutive;
      setCurrentTransaction(consecutive);
      const firstToken = await redebanToken();

      if (firstToken) {
        await redebanPay(firstToken, consecutive);
        setStartTimer(true);
        setCurrentExplanation(2);

        let limitTime = 16;
        let counterTime = 1;

        const getResponse = async (consecutive) => {
          const token = await redebanToken();
          const response = await redebanResponse(token, consecutive);
          const { Cod, Msj } = response;

          // Validate if push green button
          if ((Cod === "00" || Cod === "0") && Msj[0] === "") {
            setTimeout(() => {
              if (counterTime === limitTime) {
                updateSale(consecutive, 8);
                return;
              }
              counterTime++;
              getResponse(consecutive);
            }, 10000);
            return;
          }

          if ((Cod === "01" || Cod === "1") && Msj[0] === "") {
            setCurrentExplanation(3);

            setTimeout(() => {
              getResponse(consecutive);
            }, 10000);

            return;
          }

          // Validate if cancel transaction
          if (
            (Cod === "00" || Cod === "0") &&
            (Msj[0] === "1" || Msj[0] === "01") &&
            Msj[1] === ""
          ) {
            updateSale(consecutive, 10);
            return;
          }

          // Validate if transaction expired
          if (Cod === "02" || Cod === "2") {
            updateSale(consecutive, 8);
            return;
          }

          // Validate if transaction is wrong
          if (
            (Cod === "00" || Cod === "0") &&
            (Msj[0] === "1" || Msj[0] === "01") &&
            Msj[1] !== ""
          ) {
            updateSale(consecutive, 4);
            return;
          }

          // Validate if transaction is success
          if (
            (Cod === "00" || Cod === "0") &&
            (Msj[0] === "0" || Msj[0] === "00") &&
            Msj[1] !== ""
          ) {
            await updateSale(consecutive, 1);
            return;
          }
        };
        getResponse(consecutive);
      }
    }
  } catch (error) {
    console.error(error);
  }
};
